import {getRuntimeConfig} from './runtimeConfig';

export const APP_VERSION = '2.0.0';
export const API_BASE_URL = '/api';
export const ENABLE_REDUX_LOGGER = false;
export const {
    BACKEND_URL,
    USER_CHECK_INTERVAL = '1',
    OIDC_ISSUER_URL,
    OIDC_CLIENT_ID,
    OIDC_REDIRECT_URI: REDIRECT_URI,
    OIDC_LOGOUT_URI: SSO_LOGOUT_URI,
    GA_MEASUREMENT_ID = '',
} = getRuntimeConfig();

export const SSO_URL = (returnPath) => {
    localStorage.setItem('redirectUri', returnPath);
    const issuerUrl = OIDC_ISSUER_URL.replace(/\/$/, '');
    const url = new URL(`${issuerUrl}/protocol/openid-connect/auth`);
    url.searchParams.set('response_type', 'code');
    url.searchParams.set('scope', 'openid');
    url.searchParams.set('client_id', OIDC_CLIENT_ID);
    url.searchParams.set('redirect_uri', REDIRECT_URI);
    return url.toString();
};

export default {};
